import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useLocation, useSearchParams } from "react-router-dom";
import axios from "axios";
import config from '../../env/config';
import { auth, validateUserToken } from "../../firebase";
import { createServiceRequestOfFeedback, sendLeadNotificationEmail } from "../../API/services";
import { Link } from "react-router-dom";

import {
  // customUserByToken, getAllPolicyForFilter, getOrder,
  getTokenByUUID, getUserByToken, clearAllPreloadedQuotes
} from "../../API/services";
import Button from "../Button/Button";
import HelpModal from "../Modal/HelpModal/HelpModal";
import SlideModal from "../Modal/SlideModal/SlideModal";
// import { onAuthStateChanged, signInWithCustomToken } from "firebase/auth";
import PageLoader from "../PageLoader/PageLoader";
import MyContext from "../../Context/MainContext";


import Modal from '../../Components/Modal/Modal';
import CustomInput from "../../Components/CustomInput/CustomInput";
import AutoComplete from "../../Components/AutoComplete/AutoComplete";
import Textarea from "../../Components/Textarea/Textarea";
import CustomCheckbox from "../../Components/CheckBox/CheckBox";

import ButtonLoader from "../../Components/ButtonLoader/ButtonLoader";
import Error from "../../Components/Error/Error";

import LargeMenu from "./LargeMenu";
import "./Header.scss";
import { useLang } from "../../Utility/hooks/useLang";
import walletiiLogo from "../../Assets/images/walletii-logo.svg";



const Header = ({ currentSlide, userLoggedin, showLargeMenu = true }) => {
  const CDN_URL = config.CDN_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const searchParam = location.search;
  const redirectUrl = path + searchParam;
  const dropdownRef = useRef(null);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const contactModalRef = useRef(null);

  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const locationDropdownRef = useRef(null);

  const [menuToggle, setMenuToggle] = useState(false);
  // const [isLocationOpen, setIsLocationOpen] = useState(false);
  // const locationDropdownRef = useRef(null);


  useEffect(() => {
    const handleLocationClickOutside = (event) => {
      if (
        locationDropdownRef.current &&
        !locationDropdownRef.current.contains(event.target)
      ) {
        setIsLocationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleLocationClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleLocationClickOutside);
    };
  }, []);

  const [isGetQuotesHomeInsuranceModalOpen, setGetHomeInsuranceQuotesModalOpen] = useState(false);
  const closeGetQuotesModal = () => {
    setGetHomeInsuranceQuotesModalOpen(false);
  };
  // const [clickHereModal, setClickHereModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const handleCheckboxChange = () => {
    setIsSubscribed((prev) => !prev);
  };
  const [callBackData, setCallBackData] = useState({
    name: "",
    email: "",
    countryCode: "+968",
    companyName: "",
    mobile: "",
    description: "",
  });
  const [callBackDataError, setCallBackDataError] = useState({});
  const [isSubscribed, setIsSubscribed] = useState(true);
  const [loading, setLoading] = useState(false)
  const [serviceRequestType, setServiceRequestType] = useState("");
  const [sourceType, setSourceType] = useState("");

  // const setModal = () => {
  //   setClickHereModal(!clickHereModal);
  // };
  const modalClose = () => {
    setSuccessModal(!successModal);
  }

  const handleAutocompleteChange = (e, newValue) => {
    if (newValue?.phone) {
      setCallBackData((prev) => ({ ...prev, countryCode: newValue.phone }));
      setCallBackDataError((prev) => ({ ...prev, countryCode: "" }));
    }
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setCallBackData((prev) => ({ ...prev, [name]: value }));
    setCallBackDataError((prev) => ({ ...prev, [name]: "" }));
  };

  // const handleCheckboxChange = () => {
  //   setIsSubscribed((prev) => !prev);
  // };

  const openCreditLifeModal = (serviceRequestType, sourceType) => {
    setGetHomeInsuranceQuotesModalOpen(true)
    setServiceRequestType(serviceRequestType)
    setSourceType(sourceType)
  }

  const validateForm = () => {
    let errors = {};
    let isValid = true;
    const emailPattern = /^(^$)|([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
    const mobilePattern = /^[0-9]{7,12}$/;
    const namePattern = /^[A-Za-z ]{3,}$/;

    if (!callBackData.name.match(namePattern)) {
      errors.name = "Invalid Full Name (min 3 letters)";
      isValid = false;
    }
    if (!callBackData.email.match(emailPattern)) {
      errors.email = "Invalid email format";
      isValid = false;
    }
    if (!callBackData.mobile.match(mobilePattern)) {
      errors.mobile = "Invalid mobile number";
      isValid = false;
    }
    if (!callBackData.countryCode) {
      errors.countryCode = "Please Select Country Code";
      isValid = false;
    }
    // if (!callBackData.companyName) {
    //   errors.companyName = "Please Enter Company Name";
    //   isValid = false;
    // }
    // if (!callBackData.description || callBackData.description.length < 20 || callBackData.description.length > 350) {
    //   errors.description = "Description should be between 20 and 350 characters.";
    //   isValid = false;
    // }
    setCallBackDataError(errors);
    return { isValid, errors };
  };


  const proceedHandler = async () => {
    let validationData = validateForm(callBackData);
    if (!validationData.isValid) return;

    setLoading(true);
    const data = {
      policyId: "",
      channel: "",
      productId: "generalProduct123",
      serviceType: "GeneralLeadRequest",
      created_by_userId: "",
      created_by: "user",
      data: {
        name: callBackData.name,
        email: callBackData.email,
        policyNo: "",
        typeOfFeedBack: "",
        summary: "",
        description: callBackData.description,
        documents_list: [],
        receivePromotions: isSubscribed,
        sourceType: sourceType,
        leadType: serviceRequestType,
        ...(callBackData.mobile?.trim() && {
          mobile: callBackData.countryCode + callBackData.mobile.trim(),
        }),
      }
    };

    try {
      const resultData = await createServiceRequestOfFeedback(data);
      if (resultData?.data?.code === 0) {
        let uniqueId = resultData?.data?.payload?.service_id;
        // Send Mail After Success
        await sendLeadNotificationEmail(data.data, sourceType, uniqueId);
        setLoading(false);
        setSuccessModal(true);
        setGetHomeInsuranceQuotesModalOpen(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      setLoading(false);
    }
  };












  // derived flags for URL checks
  const isComissions = path.includes("/commissions");
  const isDashboard = path.includes("/dashboard");

  // const fullUrl =`/${location.pathname}${location.search}`;
  // debugger
  const { lang, setLang } = useLang();
  // const [lang, setLang] = useState(
  //   sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en"
  // );
  const params = useParams();
  const { t } = useTranslation();
  const [queryParams] = useSearchParams();
  const redirectUrl2 = queryParams.get('red');

  const isWalletiChannel = () => {
    try {
      const channelParam = params?.channel?.toLowerCase();
      if (channelParam) {
        return channelParam.includes("walleti");
      }

      const currentPath = location?.pathname?.toLowerCase() || "";
      const searchParamStr = location?.search?.toLowerCase() || "";
      if (currentPath.includes("walleti") || searchParamStr.includes("walleti")) {
        return true;
      }

      const storedChannel = (
        (typeof window !== "undefined" && window.sessionStorage?.getItem("channel")) ||
        (typeof window !== "undefined" && window.localStorage?.getItem("channel")) ||
        ""
      ).toLowerCase();

      if (storedChannel.includes("walleti")) {
        if (currentPath === "/" || currentPath === "/branch") return false;
        return true;
      }

      return false;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    try {
      if (params?.channel && params.channel.toLowerCase().includes("walleti")) {
        sessionStorage.setItem("channel", params.channel);
      }
    } catch (e) {
      console.error("Storage access error:", e);
    }
  }, [params?.channel]);

  // const orderId = queryParams.get('orderId');
  // const policyId = queryParams.get('policyId');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [userData, setUserData] = useState({});
  //const [menuToggle, setMenuToggle] = useState(false);
  //const [loading, setLoading] = useState(false);
  const [isAgent, setIsAgent] = useState(false);
  const { user, setUser, setCtLoading, lang1, setLang1 } = useContext(MyContext);
  const [isArabicLang, setisArabicLang] = useState(false);


  const langChange = (e) => {
    // console.log("VAlue ---->> ", e.target, e.target.checked);
    const selectedLang = e.target.checked ? 'ar' : 'en';
    setLang1(selectedLang)
    // sessionStorage.setItem("lang", selectedLang);
    setLang(selectedLang);
    // window.location.reload();
  }

  const signOut = async () => {
    localStorage.removeItem('vehicleData');
    localStorage.removeItem("addonIdList")
    localStorage.removeItem("addonIdListValues")
    clearAllPreloadedQuotes();
    setLoading(true);
    setIsLoggedIn(false);
    await auth.signOut();
    document.cookie = "Authorization=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "idToken=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    clearMisTameenCookies()
    // ✅ Prevent redirect for opal_motor_branch or opalmotoruat or walleti channels
    if (path.includes("opal_motor_branch") || path.includes("opalmotoruat") || isWalletiChannel()) {
      setLoading(false);
      return;
    }

    // ✅ Redirect for other cases
    if (path.includes("branchmotor") || path.includes("branch")) {
      window.location.href = '/branch';
    } else {
      if (isComissions) {
        window.location.href = '/commissions/login';
      } else if (isDashboard) {
        window.location.href = '/dashboard/login';
      } else {
        window.location.href = '/';
      }
    }
  };
  const getCookie = (name) => {
    let dc = document.cookie;
    let prefix = name + "=";
    let begin = dc.indexOf("; " + prefix);
    let end;
    if (begin === -1) {
      begin = dc.indexOf(prefix);
      if (begin !== 0) return null;
    }
    else {
      begin += 2;
      end = document.cookie.indexOf(";", begin);
      if (end === -1) {
        end = dc.length;
      }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
  }
  const findDomain = () => {
    let domain = '';
    if (window.location.host.indexOf("localhost") !== -1) {
      domain = ".localhost";
    } else if (window.location.host.indexOf("upsure.io") !== -1) {
      domain = ".upsure.io"
    } else if (window.location.host.indexOf("tameen.om") !== -1) {
      domain = ".tameen.om"
    }
    return domain;
  }
  const clearMisTameenCookies = () => {
    try {
      // Get all cookies
      const cookies = document.cookie.split(";");
      // Define mis.tameen.om specific domains
      const misDomains = ["staging.tameen.om", ".tameen.om", "erp.tameen.om", "mis.tameen.om"];
      // Clear each cookie
      cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");

        const name =
          eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

        if (name) {
          // Clear for each mis domain (root path only)

          misDomains.forEach((domain) => {
            // Basic clearing

            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;

            // Clear with Secure flag (for HTTPS)

            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain};Secure`;

            // Clear with different SameSite values

            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain};Secure;SameSite=Strict`;

            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain};Secure;SameSite=Lax`;

            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain};Secure;SameSite=None`;
          });
        }
      });

      console.log("All mis.tameen.om cookies cleared successfully");

      return true;
    } catch (error) {
      console.error("Error clearing mis.tameen.om cookies:", error);

      return false;
    }
  };
  // const checkLogin=(id)=>{
  //   if(!!getCookie("Authorization")){
  //     const newRequest = {
  //       "apiKey": "watania",
  //       "secretKey": "DA5EDB62977E2DDA159F25C2D6469",
  //       "brokerCode": "upsure",
  //       "channel": params.channel,
  //       "categoryCode": "OWILFTM"
  //     };
  //     newGetLifeEnquiry('/api/lsenquiry/enquiry/channelPartner/'+id, newRequest).then(response =>{
  //       // console.log("quoteDetails",response);
  //       // debugger
  //       let intervalId;
  //       if(response.quoteDetails){
  //         onAuthStateChanged(auth, (user) => {
  //             // console.log("user2222",user);
  //             if (user) {
  //               user.getIdToken().then(idToken =>{
  //                 // console.log("idtoken",idToken);
  //                 customUserByToken({'token':idToken,"application":'digi-life'}).then(res =>{
  //                   console.log("token22222",res);
  //                   if(res.code ===0 && (response.created_by_userId === res.uuid || response.created_for_userId === res.uuid)){
  //                     console.log("else12");
  //                     setUserData(res);
  //                     setIsLoggedIn(true);
  //                     setLoading(false);
  //                   }else{
  //                     setIsLoggedIn(false);
  //                     setLoading(false);
  //                     console.log("else11");
  //                     navigate('/unauthorized');
  //                   }
  //                 }).catch((err)=>{
  //                   console.log("err",err);
  //                   setIsLoggedIn(false);
  //                   setLoading(false);
  //                 });
  //               });
  //               intervalId = setInterval(() => {
  //                 if (!user) {
  //                     clearInterval(intervalId);
  //                     console.log("in signed out USER ......");
  //                     document.cookie = "Authorization=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //                     document.cookie = "idToken=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  //                     setIsLoggedIn(false);
  //                     signOut();
  //                     return;
  //                 }

  //                 user.getIdToken().then(idToken => {
  //                   setIsLoggedIn(true);
  //                     const date = new Date();
  //                     const expireDate = new Date(date.getUTCFullYear() + 68, date.getMonth(), date.getDate()).toUTCString();
  //                     document.cookie = `Authorization=${idToken};domain=${findDomain()};expires=${expireDate};path=/`;
  //                     document.cookie = "idToken=" + idToken + ";domain=" + findDomain() + ";expires=" + expireDate + ";path=/";

  //                 }).catch(error => {
  //                     console.log("IN EXCEPTION 2nd", error);
  //                 });
  //             }, 5000);
  //             }else{ 
  //               setIsLoggedIn(false);
  //               setLoading(false);
  //               clearInterval(intervalId);
  //               console.log("in signed out");
  //               document.cookie = "Authorization=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //               document.cookie = "idToken=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  //               navigate('/');
  //             };
  //         });
  //       }
  //     })
  //   }else{
  //     console.log("else10");
  //   //  window.location.href=`localhost:3000/${path}${searchParam}`
  //      window.location.href=`https://upsureuat.watania.ae/authentication/login/signin?redirect=https://upsureuat.watania.ae/manage/authentication/auth_handler?r=${path}${searchParam}`
  //   }
  // }
  // https://upsureuat.watania.ae/authentication/login/signin?redirect=https://upsureuat.watania.ae/manage/authentication/auth_handler?r=
  // useEffect(() => {
  //   console.log("getCookie()",getCookie("Authorization")); 

  //     if(enquiryId){
  //       checkLogin(enquiryId);
  //     }else if(orderId){
  //       const getOrderRequest = {
  //         "apiKey": "watania",
  //         "secretKey": "DA5EDB62977E2DDA159F25C2D6469",
  //         "brokerCode": "upsure",
  //         "channel": params.channel,
  //         "categoryCode": "OWILFTM"
  //       }
  //       getOrder(`/api/lsorder/channelPartner/${orderId}`, getOrderRequest).then(response =>{
  //         if(response.enquiry_id){
  //           checkLogin(response.enquiry_id);
  //         }
  //       })
  //     }else if(!!policyId){
  //       getAllPolicyForFilter(policyId).then(resp =>{
  //         if(resp && resp.status ==200){
  //           const newPayload = resp.data.data && resp.data.data.getAllPolicyForFilter && resp.data.data.getAllPolicyForFilter.hits &&  resp.data.data.getAllPolicyForFilter.hits.hits[0] && resp.data.data.getAllPolicyForFilter.hits.hits[0]._source;
  //            const getOrderRequest = {
  //             "apiKey": "watania",
  //             "secretKey": "DA5EDB62977E2DDA159F25C2D6469",
  //             "brokerCode": "upsure",
  //             "channel": newPayload?.channel,
  //             "categoryCode": "OWILFTM"
  //             };
  //             newPayload && newPayload.order_id && getOrder(`/api/lsorder/channelPartner/${newPayload.order_id}`, getOrderRequest).then(response =>{
  //               if(response.enquiry_id){
  //                 checkLogin(response.enquiry_id);
  //               }
  //             })
  //         }
  //       }).catch(err=>{
  //         console.log(err);
  //       });
  //     }
  //     else{
  //     if(path ==(`/${params.insuranceType}/${params.channel}`)){
  //       searchParam ? navigate(`/${params.insuranceType}/${params.channel}${searchParam}`): navigate(`/${params.insuranceType}/${params.channel}`);
  //       setIsLoggedIn(false);
  //     }else{
  //       // navigate('/unauthorized');
  //      navigate('/${params.insuranceType}/term/agentcode')
  //       setIsLoggedIn(false);
  //     }
  //   }
  //   }, []);
  // useEffect(() => {
  //   if (getCookie("Authorization")) {
  //     setIsLoggedIn(true);
  //     let intervalId;
  //     console.log("auth33 ---> ", user);
  //     getUserByToken(getCookie("Authorization")).then(resp=>{
  //       console.log("resoe44",resp);
  //       if(resp.data.code ==0){
  //         setUser({
  //           ...user,
  //           userUUID:resp.data.value.uuid});
  //       onAuthStateChanged(auth, (userT) => {
  //           console.log("user333 ---> ", userT);
  //           if (userT) {
  //               console.log("in signed in USER");
  //               //console.log(domain);
  //               userT.getIdToken()
  //                   .then(idToken => {
  //                       console.log("local idToken",idToken);
  //                       let configJson = {
  //                           "token": idToken,
  //                           "application": "digi-life" //asdasd
  //                       }
  //                       axios.post( 'https://api.tameen.om/api/authentication/v1/getuserdetails', configJson).then((response) => {
  //                           console.log("USER DATA ---> ", response);
  //                           const userData = { mobile: response.data.mobile, popupMobileNUmber: response.data && response.data.mobile && response.data.mobile.includes('+91') ?response.data && response.data.mobile && response.data.mobile.replace("+91","") : '' + response.data.mobile, fullName: response.data.fullName, userUUID: response.data.uuid, userEmail:response.data.email};
  //                           setUserData(userData);
  //                           setUser(userData);
  //                       })
  //                   }).catch(error => {
  //                       console.log("error",error)
  //                   });
  //               intervalId = setInterval(() => {
  //                   // console.log("local");
  //                   if (!userT) {
  //                       clearInterval(intervalId);
  //                       console.log("local3");
  //                       console.log("in signed out USER ......");
  //                       document.cookie = "Authorization=;domain=" +findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //                       // document.cookie = "idToken=;domain=" +findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //                       setIsLoggedIn(false);
  //                       signOut();
  //                       setUser({});
  //                       return;
  //                   }
  //                   userT.getIdToken()
  //                       .then(idToken => {
  //                           setIsLoggedIn(true);
  //                           console.log("local idToken444",idToken);
  //                           var date = new Date();
  //                           let expireDate = new Date(date.getUTCFullYear() + 68, date.getMonth(), date.getDay()).toUTCString();
  //                           document.cookie = "Authorization=" + idToken + ";domain=" +findDomain() + ";expires=" + expireDate + ";path=/";
  //                           document.cookie = "idToken=" + idToken + ";domain=" +findDomain() + ";expires=" + expireDate + ";path=/";
  //                       }).catch(error => {
  //                           console.log("IN EXCEPTION 2nd")
  //                       });
  //               }, 5000);
  //           }
  //           else {
  //               clearInterval(intervalId);
  //               console.log("local5",user);
  //               console.log("in signed out USERRRghgh");
  //               document.cookie = "Authorization=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //               // document.cookie = "idToken=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //               // this.signOut();
  //               setIsLoggedIn(false);
  //           }
  //       }); 
  //     }else{
  //       console.log("11error in getting user");
  //       // navigate('/unauthorized')
  //     }
  //   }).catch(err=>{
  //     console.log("222error in getting user",err);
  //     // navigate('/unauthorized')
  //   })
  // } else {
  //     // console.log("local4");
  //     setIsLoggedIn(false);
  // }
  // }, []);
  // useEffect(() => {
  //   // const localToken= getCookie("Authorization")
  //   // console.log("getCooki idtoken",getCookie("Authorization"), "\n localToken-",localToken);
  //   if (getCookie("Authorization")) {
  //     setIsLoggedIn(true);
  //     let intervalId;
  //     console.log("auth33 ---> ", user);
  //     // signInWithCustomToken(auth,localToken)
  //     // .then((userCredential) => {
  //     //   const user = userCredential.user;
  //     //   console.log("user token000", userCredential,user);
  //       onAuthStateChanged(auth, (userT) => {
  //           console.log("user333 ---> ", userT);
  //           if (userT) {
  //               console.log("in signed in USER");
  //               //console.log(domain);
  //               userT.getIdToken()
  //                   .then(idToken => {
  //                       console.log("local idToken00",idToken);
  //                       let configJson = {
  //                           "token": idToken,
  //                           "application": "digi-life" //asdasd
  //                       }
  //                       axios.post( `${config.BASE_URL}/api/authentication/v1/getuserdetails`, configJson).then((response) => {
  //                           console.log("USER DATA ---> ", response);
  //                           const userData = { mobile: response.data.mobile, popupMobileNUmber: response.data && response.data.mobile && response.data.mobile.includes('+91') ?response.data && response.data.mobile && response.data.mobile.replace("+91","") : '' + response.data.mobile, fullName: response.data.fullName, userUUID: response.data.uuid, userEmail:response.data.email};
  //                           setUserData(userData);
  //                           setUser(userData);
  //                           setCtLoading(false);
  //                       })
  //                   }).catch(error => {
  //                       console.log("error",error)
  //                   });
  //               intervalId = setInterval(() => {
  //                   // console.log("local");
  //                   if (!userT) {
  //                       clearInterval(intervalId);
  //                       console.log("local3");
  //                       console.log("in signed out USER ......");
  //                       document.cookie = "Authorization=;domain=" +findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //                       document.cookie = "idToken=;domain=" +findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //                       setIsLoggedIn(false);
  //                       signOut();
  //                       setUser({});
  //                       return;
  //                   }
  //                   userT.getIdToken()
  //                       .then(idToken => {
  //                           setIsLoggedIn(true);
  //                           // console.log("local idToken444",idToken);
  //                           var date = new Date();
  //                           let expireDate = new Date(date.getUTCFullYear() + 68, date.getMonth(), date.getDay()).toUTCString();
  //                           document.cookie = "Authorization=" + idToken + ";domain=" +findDomain() + ";expires=" + expireDate + ";path=/";
  //                           document.cookie = "idToken=" + idToken + ";domain=" +findDomain() + ";expires=" + expireDate + ";path=/";
  //                       }).catch(error => {
  //                           console.log("IN EXCEPTION 2nd")
  //                       });
  //               }, 5000);
  //           }
  //           else {
  //               clearInterval(intervalId);
  //               console.log("local5",user);
  //               console.log("in signed out USERRRghgh");
  //               document.cookie = "Authorization=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //               document.cookie = "idToken=;domain=" + findDomain() + ";expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //               // this.signOut();
  //               setIsLoggedIn(false);
  //           }
  //       }); 
  //   //     })
  //   // .catch((error) => {
  //   //   const errorCode = error.code;
  //   //   console.log("error",error);
  //   // });
  // } else {
  //     // console.log("local4");
  //     if(path !==(`/${params.insuranceType}/${params.channel}`) && searchParam){
  //       window.location.href=`${config.TAMEEN_STAGING}/authentication/login/signin?redirect=${config.TAMEEN_STAGING}/manage/authentication/auth_handler?r=${path}${searchParam}`
  //       setIsLoggedIn(false);
  //       //setCtLoading(false);
  //       //setLoading(false);
  //     }
  // }
  // }, []);
  useEffect(() => {
    let intervalId;

    const authCookie = getCookie("Authorization");
    if (authCookie || userLoggedin) {
      getUserByToken(authCookie).then(resp => {
        if (resp.data.code === 0) {
          getTokenByUUID(resp.data.value.uuid)
            .then(getTokenRes => {
              validateUserToken(getTokenRes.data.value)
                .then(() => {
                  setIsLoggedIn(true);

                  auth.onAuthStateChanged((userT) => {
                    if (userT) {
                      userT.getIdToken()
                        .then(idToken => {
                          const configJson = {
                            token: idToken,
                            application: "digi-life"
                          };

                          axios.post(
                            config.BASE_URL + "/api/authentication/v1/getuserdetails",
                            configJson
                          ).then((response) => {
                            const userData = {
                              mobile: response.data.mobile,
                              popupMobileNUmber: response.data.mobile?.includes("+91")
                                ? response.data.mobile.replace("+91", "")
                                : response.data.mobile,
                              fullName: response.data.fullName,
                              userUUID: response.data.uuid,
                              userEmail: response.data.email
                            };
                            setUserData(userData);
                            setUser(userData);
                            if (response.data.uuid) {
                              if (redirectUrl2) {
                                navigate(redirectUrl2, { replace: true });
                              }

                            }
                            setCtLoading(false);
                          });
                        })
                        .catch(error => console.log("error", error));

                      // Refresh token every 50s
                      intervalId = setInterval(() => {
                        userT.getIdToken()
                          .then(idToken => {
                            setIsLoggedIn(true);
                            const expireDate = new Date(Date.now() + 1000 * 60 * 60 * 24).toUTCString();
                            document.cookie = `Authorization=${idToken};domain=${findDomain()};expires=${expireDate};path=/`;
                            document.cookie = `idToken=${idToken};domain=${findDomain()};expires=${expireDate};path=/`;
                          })
                          .catch(() => console.log("Error refreshing token"));
                      }, 50000);
                    } else {
                      clearInterval(intervalId);
                      document.cookie = `Authorization=;domain=${findDomain()};expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
                      document.cookie = `idToken=;domain=${findDomain()};expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
                      setIsLoggedIn(false);
                    }
                  });
                })
                .catch(error => {
                  console.error("Error signing in with token: ", error);
                  setIsLoggedIn(true);
                });
            });
        } else {
          if ((path.includes("documents-upload") || path.includes("upload-success")) && params.channel !== "opalmotoruat" && params.channel !== "opal_motor_branch" && !isWalletiChannel()) {
            clearMisTameenCookies();
            navigate(redirectUrl)
            return
          }
          if (((searchParam.includes("enquiryId") || searchParam.includes("orderId"))) && !path.includes("login")) {
            clearMisTameenCookies()
            redirectUrl ? navigate(`/login?red=${redirectUrl}`, { replace: true }) : navigate("/")
            return;
          }
        }
      });
    } else {
      if ((path.includes("documents-upload") || path.includes("upload-success")) && params.channel !== "opalmotoruat" && params.channel !== "opal_motor_branch" && !isWalletiChannel()) {
        clearMisTameenCookies()
        navigate(redirectUrl)
        return;
      }
      if (((searchParam.includes("enquiryId") || searchParam.includes("orderId"))) && !path.includes("login")) {
        clearMisTameenCookies();
        redirectUrl ? navigate(`/login?red=${redirectUrl}`, { replace: true }) : navigate("/")
        return;
      }
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [userLoggedin, redirectUrl]);

  const HelpModalOpenModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const [isSlideOpen, setSlideModalOpen] = useState(false);

  const SlideModalOpen = () => {
    setSlideModalOpen(true);

  }

  const toggleModal = () => {
    setSlideModalOpen(!isSlideOpen);
  };

  const SlideModalClose = () => {
    setSlideModalOpen(false);
  }

  const handleDropdownClick = (event) => {
    event.stopPropagation();
  };

  const menuHandler = () => {
    setMenuToggle(!menuToggle)
  }

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef?.current?.contains(event.target)) {
      setMenuToggle(false);
    }
  };
  const ProfileModal = () => {
    setProfileOpen(!isProfileOpen);
  };
  const agentCustomerRedirection = (path) => {
    if (isAgent) {
      window.location.href = `/agent/${params.channel}/dashboard`
    } else {
      window.location.href = `/${path}`
    }
  }
  // const isArabicLang = lang === "ar";
  useEffect(() => {
    setisArabicLang(lang1 === "ar")
  }, [lang1])

  const claimAssistance = () => {

  }

  const handlePopUpClick = (event) => {
    event.stopPropagation()
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (contactModalRef.current && !contactModalRef.current.contains(event.target) && !event.target.closest('.SignIn')) {
        setProfileOpen(false)
      }
    }

    if (isProfileOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    };
  }, [isProfileOpen])

  const handleLogoClick = () => {
    const currentPath = location.pathname;
    if (currentPath.includes('opalmotoruat') || currentPath.includes('opal_motor_branch') || isWalletiChannel()) return;

    if (currentPath.includes('branchtravel') || currentPath.includes('branchmotor') || currentPath.includes('branchdomestic')) {
      navigate((lang === "ar" ? "/ar" : "") + "/branch");
    } else {
      if (isDashboard) {
        navigate('/dashboard');
        return;
      } else if (isComissions) {
        navigate('/commissions');
        return;
      } else {
        navigate((lang === "ar" ? "/ar" : "") + "/");
      }
    }
  };
  // console.log("userData",userData,isLoggedIn);
  const fullName = userData?.fullName;
  if (loading) return <PageLoader />;
  return (
    <div className="header">
      {/* container div starts here  */}
      <div className="container">
        {/* <div className={isArabicLang ? "inn-head rgt-direction" : "inn-head"}> */}
        <div className={isArabicLang ? "inn-head" : "inn-head"}>
          <div className="hd-section">
            {isWalletiChannel() ? (
              <div className="walletiiBrandGroup">
                <div className="walletiHeaderLogo" onClick={handleLogoClick}>
                  <img src={walletiiLogo} alt="Walletii" title="Walletii" />
                </div>
                <div className="walletiiBrandDivider"></div>
                <div className="logoOnicItem walletiiTameenLogo" onClick={handleLogoClick}>
                  <div className="lnd-logo">
                    <div className="logo">Tameen</div>
                  </div>
                  {lang === "ar" ? <span className="onic-group">(مجموعة شركات أونك)</span> : <span className="onic-group">(ONEIC Group Company)</span>}
                </div>
              </div>
            ) : (
              <div className="logoOnicItem" onClick={handleLogoClick}>
                <div className="lnd-logo">
                  <div className="logo">Tameen</div>
                </div>

                {lang === "ar" ? <span className="onic-group">(مجموعة شركات أونك)</span> : <span className="onic-group">(ONEIC Group Company)</span>}
              </div>
            )}

            {showLargeMenu && (
              <div className="mobile-hidden">
                <LargeMenu openCreditLifeModal={openCreditLifeModal} />
              </div>
            )}
            {/* desktop starts here */}
            <div className="mobile-hidden">
              <div className="menu-section">
                <div className="contactSec">
                  <div className="contactBtnItem" onClick={ProfileModal}>{lang === "ar" ? "إتصل بنا" : "CONTACT US"}</div>
                  {isProfileOpen && (
                    <div className="ContactUsDiv" ref={contactModalRef} onClick={handlePopUpClick}>
                      <div className="ContactList">
                        <div className="ContactAll">
                          Contact us for all your queries
                        </div>
                        <div className="whatsappFlx">
                          <div className="whatsappImgItem">
                            <img
                              src={`${CDN_URL}land_whatsapp_inc.webp`}
                              alt="whatsapp"
                              title="whatsapp"
                              width={24}
                              height={24}
                              loading="lazy"
                            />
                          </div>
                          <div className="textItem">
                            <p className="labelItemTxt">WhatsApp</p>
                            <a className="valueItemTxt" href="https://wa.me/96872227122" target="_blank">+968 72227122</a>
                          </div>
                        </div>
                        <div className="emailFlx">
                          <div className="emailImgItem">
                            <img
                              src={`${CDN_URL}land_mail_inc.webp`}
                              alt="email"
                              title="email"
                              width={24}
                              height={24}
                              loading="lazy"
                            />
                          </div>
                          <div className="emailTextItem">
                            <p className="emailLabeTxt">Email</p>
                            <a
                              className="emailAddress"
                              href="mailto:care@tameen.om"
                            >
                              care@tameen.om
                            </a>
                          </div>
                        </div>
                        <div className="callUsFlx">
                          <div className="callUsImgItem">
                            <img
                              src={`${CDN_URL}land_ph_inc.webp`}
                              title="phone"
                              alt="phone"
                              width={24}
                              height={24}
                              loading="lazy"
                            />
                          </div>
                          <div className="callUsTextItem">
                            <p className="callLabeTxt">Call Us</p>
                            <a className="callValueTxt" href="tel:+96824991999" target="_blank">+968 2499 1999</a>
                          </div>
                        </div>
                        <div className="claimAsstBtnFlx">
                          <Button
                            label="Claim Assistance"
                            status={true}
                            isRightIcon={false}
                            buttonType={"AddonAdd-btn"}
                            clickFunction={() => navigate((lang === "ar" ? "/ar" : "") + "/claims-assistance")}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* {isLoggedIn ? null : (
                  <div className="SignIn">
                    {lang === "ar" ? "تسجيل الدخول" : "SIGN IN"}
                  </div>
                )} */}
                {
                  isComissions || isDashboard ? null : (
                    <div className="lang-swipe">
                      <div className="switch">
                        <input
                          id="language-toggle"
                          className="check-toggle check-toggle-round-flat"
                          type="checkbox"
                          checked={lang === "ar"}
                          onChange={(e) => langChange(e)}
                        />
                        <label htmlFor="language-toggle"></label>
                        <span className="on">ENG</span>
                        <span className="off">عربي</span>
                      </div>
                    </div>
                  )
                }
                {/* <div className="helpicon" onClick={HelpModalOpenModal}>{t("HELP")}</div>             */}
                <SlideModal isOpen={isSlideOpen} onClose={toggleModal} isLoggedIn={isLoggedIn} fullName={fullName} mobile={user?.mobile} signOut={signOut} />
                {/* <div className="hamburgicon" onClick={SlideModalOpen}>
              <img src={`${CDN_URL}hamburg.webp`} alt="hamburg" />
            </div> */}
                {!isLoggedIn ? (
                  <div
                    className={isArabicLang ? "LoginBtn" : "LoginBtn"}
                    onClick={() => (window.location.href = "/manage")}
                  >
                  </div>
                ) : (
                  <div
                    className={isArabicLang ? "ProfileInc" : "ProfileInc"}
                    onClick={() => menuHandler()}
                  >
                    {false ? (
                      fullName[0].toUpperCase()
                    ) : (
                      <i className="fa-regular fa-user"></i>
                    )}
                    {menuToggle ? (
                      <div className="profile-div" ref={dropdownRef} onClick={handlePopUpClick}>
                        <div className="pro-head">
                          {/* <h4>Name</h4>
                              <h4>Email</h4> */}
                          {fullName ? <h4>Name: {fullName}</h4> : null}
                          <h4>Mobile :{user?.mobile}</h4>
                        </div>
                        <div className="prof-footer">
                          {/* <div className="snt-btnsec">
                          <Button
                            className="md-bt"
                            label={isAgent ? t("MY_DASHBOARD") : t("MY_ACCOUNT")}
                            status={true}
                            isIcon={false}
                            clickFunction={() => { agentCustomerRedirection("manage") }}
                            buttonType={
                              isArabicLang ? "signout-btn" : "signout-btn"
                            }
                          />
                        </div> */}
                          <div className="snt-btnsec">
                            <Button
                              className="md-bt"
                              label={t("SIGN_OUT")}
                              status={true}
                              isIcon={false}
                              clickFunction={() => signOut()}
                              buttonType={
                                isArabicLang ? "signout-btn" : "signout-btn"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            </div>
            {/* desktop ends here */}

            <div className="tab-visible mobile-hidden">
              <SlideModal isOpen={isSlideOpen} onClose={toggleModal} isLoggedIn={isLoggedIn} fullName={fullName} mobile={user?.mobile} signOut={signOut} />
              <div className="hamburgicon" onClick={SlideModalOpen}>
                <img
                  src={`${CDN_URL}hamburg.webp`}
                  alt="hamburg"
                  width="28"
                  height="22"
                  loading="lazy"
                />
              </div>
            </div>

            {/* mobile starts here */}
            <div className="desktop-hidden">
              <div className="menu-section">
                <div className="lang-swipe">
                  <div className="switch">
                    <input
                      id="language-toggle"
                      className="check-toggle check-toggle-round-flat"
                      type="checkbox"
                      checked={lang === "ar"}
                      onChange={(e) => langChange(e)}
                    />
                    <label htmlFor="language-toggle"></label>
                    <span className="on">ENG</span>
                    <span className="off">عربي</span>
                  </div>
                </div>
                {/* <div className="helpicon" onClick={HelpModalOpenModal}>{t("HELP")}</div>             */}
                <SlideModal isOpen={isSlideOpen} onClose={toggleModal} isLoggedIn={isLoggedIn} fullName={fullName} mobile={user?.mobile} signOut={signOut} />
                <div className="hamburgicon" onClick={SlideModalOpen}>
                  <img
                    src={`${CDN_URL}hamburg.webp`}
                    alt="hamburg"
                    width="28"
                    height="22"
                    loading="lazy"
                  />
                </div>
                <div className="mobile-hidden">
                  {!isLoggedIn ? (
                    <div
                      className={isArabicLang ? "LoginBtn" : "LoginBtn"}
                      onClick={() => (window.location.href = "/manage")}
                    >
                      {t("")}
                    </div>
                  ) : (
                    <div
                      ref={dropdownRef}
                      className={isArabicLang ? "ProfileInc" : "ProfileInc"}
                      onClick={() => menuHandler()}
                    >
                      {false ? (
                        fullName[0].toUpperCase()
                      ) : (
                        <i className="fa-regular fa-user"></i>
                      )}
                      {menuToggle ? (
                        <div className="profile-div">
                          <div className="pro-head">
                            {fullName ? <h4>Name: {fullName}</h4> : null}
                            <h4>Mobile :{user?.mobile}</h4>
                          </div>
                          <div className="prof-footer">
                            <div className="snt-btnsec">
                              <Button
                                className="md-bt"
                                label={t("SIGN_OUT")}
                                status={true}
                                isIcon={false}
                                clickFunction={() => signOut()}
                                buttonType={
                                  isArabicLang ? "signout-btn" : "signout-btn"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* mobile ends here */}
            <HelpModal HelpModalOpenModal={isModalOpen} closeModal={closeModal} />
          </div>
        </div>
      </div>
      {/* container div ends here  */}


      {/* HOME INSURANCE MODAL STARTS HERE */}
      <Modal isOpen={isGetQuotesHomeInsuranceModalOpen} closeModal={closeGetQuotesModal} widthClass="modal-width-40">
        <div className={lang === "ar" ? "homeReqModalTitle dirRtl" : "homeReqModalTitle"}>
          {/* {lang === "ar" ? "أفضل عروض التأمين، دائماً!" : "Best Insurance Offers, Always!"} */}
          {sourceType}
        </div>
        <div className={lang === "ar" ? "homeReqSubTxt dirRtl" : "homeReqSubTxt"}>
          {lang === "ar" ? "يرجى تعبئة بياناتك، وسيتواصل معك موظفينا في أقرب وقت." : "Please fill in your details, and our expert insurance advisor will contact you shortly."}
        </div>
        {/* <div className="sourceTypeHdTxt">
          
        </div> */}
        <div className="homeReqFromFx">

          <div className="homeReqFieldItemHalf">
            <CustomInput label={lang === "ar" ? "* الاسم الكامل" : "Name *"}
              name="name"
              value={callBackData.name}
              onChange={onChangeHandler}
            />
            {callBackDataError.name && <Error msg={callBackDataError.name} />}
          </div>
          <div className="homeReqFieldMobItem">
            <div className="cntCodeItem">
              <AutoComplete name="countryCode" placeholder={t("PLACEHOLDER_RTO_CODE")} value={{ phone: callBackData.countryCode }} onChange={handleAutocompleteChange} />
              {callBackDataError.countryCode && <Error msg={callBackDataError.countryCode} />}
            </div>
            <div className="mobileNumItem">
              <CustomInput
                label={lang === "ar" ? "* رقم الهاتف " : "Mobile Number *"}
                type="tel"
                name="mobile"
                maxLength={10}
                value={callBackData.mobile}
                onChange={onChangeHandler}
              />
              {callBackDataError.mobile && <Error msg={callBackDataError.mobile} />}
            </div>
          </div>

          <div className="homeReqFieldItem">
            <CustomInput
              label={lang === "ar" ? "عنوان البريد الإلكتروني" : "Email"}
              type="email"
              name="email"
              value={callBackData.email}
              onChange={onChangeHandler}
            />
            {callBackDataError.email && <Error msg={callBackDataError.email} />}
          </div>
          {/* <div className="callBkFieldItem">
            <CustomInput 
              label={t("CompanyName")}
              name="companyName"
              value={callBackData.companyName}
              onChange={onChangeHandler}
            />
            {callBackDataError.companyName && <Error msg={callBackDataError.companyName} />}
          </div> */}
          <div className="homeReqFieldItem">
            <Textarea
              label={lang === "ar" ? "اختصار" : "Brief Details"}
              name="description"
              value={callBackData.description}
              onChange={onChangeHandler}
            />
            {callBackDataError.description && <Error msg={callBackDataError.description} />}
          </div>
          <div className="homeReqItemFx">
            {lang === "ar" ?
              <div className="itemFx dirRtl"><i className="fa-solid fa-star"></i> المزيد من التوفير
              </div>
              :
              <div className="itemFx"><i className="fa-solid fa-star"></i> Fast Response</div>
            }
            {lang === "ar" ?
              <div className="itemFx dirRtl"><i className="fa-solid fa-star"></i> مقارنة العروض</div>
              :
              <div className="itemFx"><i className="fa-solid fa-star"></i> Compare Offers</div>
            }
            {lang === "ar" ?
              <div className="itemFx dirRtl"><i className="fa-solid fa-star"></i> استجابة سريعة</div>
              :
              <div className="itemFx"><i className="fa-solid fa-star"></i> More Savings</div>
            }
          </div>
          <div className="homeReqChkItem">
            <div className="chkItem">
              <CustomCheckbox colorClass="blue"
                checked={isSubscribed}
                onChange={handleCheckboxChange}
              />
            </div>
            {lang === "ar" ?
              <div className="homeReqChkItemTxtAr dirRtl">
                بالنقر على "المتابعة"، أؤكد أنني قرأت ووافقت على سياسة الخصوصية والشروط والأحكام
              </div>
              :
              <div className="homeReqChkItemTxt">By clicking "Proceed," I confirm that I have read and agree to the <a href="/privacy-policy" target="_blank">Privacy Policy</a> and <a href="/terms-and-conditions" target="_blank">Terms & Conditions.</a></div>
            }
          </div>
          <div className=""></div>
          <div className="homeReqBtn">
            {loading ?
              <ButtonLoader bgColor="#d95e76" textColor="#fff" />
              :
              <Button label={lang === "ar" ? "متابعه" : "PROCEED"}
                status={true}
                isIcon={false}
                clickFunction={proceedHandler}
                buttonType="proceed-btn"
              />
            }
          </div>
        </div>
      </Modal>
      {/* HOME INSURANCE MODAL ENDS HERE */}

      {/* HOME INSURANCE SUCCESS MODAL STARTS HERE */}
      <Modal isOpen={successModal} closeModal={modalClose} widthClass="modal-width-45">
        <div className="reqCalBkThankFlx">
          <div className="reqTnkInc">
            <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" fill="none" viewBox="0 0 120 120">
              <path fill="#000" d="M73.448 17.711s-5.612-1.403-16.326-1.148c-10.715.255-44.516.638-46.557 8.419-2.04 7.78 3.7 80.713 4.465 84.95.765 4.236 4.209 4.236 17.73 4.236 13.52 0 49.49-5.64 52.55-7.425 3.062-1.786 4.21-6.378 4.21-6.378L73.448 17.711Z" />
              <path fill="#599EFC" d="M80.082 24.088c-1.02-2.423 1.125-7.71-13.138-6.888-13.266.766-45.34 3.166-50 8.546-3.856 4.452.51 78.035 4.719 82.272 4.209 4.236 64.316-3.149 67.475-6.506 3.764-3.999-9.056-77.424-9.056-77.424Z" />
              <path fill="#80D092" d="M82.632 26.512s-2.806-6.888-4.21-7.398c-1.402-.51-56.632 6.377-58.418 9.311-1.786 2.934 7.015 70.154 8.163 73.853 1.148 3.699 34.834-1.096 53.52-6.103 7.195-1.928.945-69.663.945-69.663Z" />
              <path fill="#FDE580" d="M21.645 27.143s51.41-10.102 57.543-9.38c6.133.721 13.272 42.851 21.466 53.574 7.306 9.56 6.213 11.486-12.086 18.94-24.352 9.922-42.751 9.922-48.884 8.479C33.55 97.313 20.382 39.589 19.3 34.178c-1.082-5.412 0-6.494 2.345-7.035Z" />
              <path fill="#FD6B6A" d="M24.004 18.86s9.524.89 11.037 2.759c1.514 1.869-1.157 10.058 3.205 10.948 4.361.89 25.368-2.225 27.771-4.985 2.404-2.759 3.205-12.728-4.984-13.351-8.19-.623-5.697-2.582-9.168-6.142-3.472-3.56-8.902-2.848-9.792 1.958-.89 4.807-6.23 5.34-11.571 5.074-5.34-.267-6.498 3.738-6.498 3.738Z" />
              <path fill="#fff" d="M47.279 9.024c-2.27.534-4.273 5.518.623 4.984 4.895-.534 3.382-6.053-.623-4.984Z" />
              <path fill="#000" d="M37.566 21.469c16.24-2.077 29.079-3.21 27.631-3.588-1.447-.377-4.028-2.014-7.93-2.454-3.903-.441-12.274 2.769-19.575 1.95-7.3-.817-10.322 0-8.497.567 1.825.567 7.301 1.888 8.371 3.525Z" />
              <path fill="#fff" d="M30.369 41.112s46.146-7.166 48.439-9.03c2.293-1.862-10.892.43-18.774 2.007-7.882 1.577-24.936 3.726-28.519 4.873-3.583 1.146-3.726 2.436-1.146 2.15Zm2.027 8.714s46.146-7.165 48.44-9.028c2.292-1.863-10.892.43-18.775 2.006-7.882 1.577-24.936 3.726-28.519 4.873-3.582 1.146-3.726 2.436-1.146 2.15Z" />
              <path fill="#80D092" d="M43.247 59.218s38.138-6.512 40.43-8.375c2.293-1.863-10.891.43-18.773 2.006-7.882 1.577-16.927 3.072-20.51 4.219-3.583 1.146-3.726 2.436-1.147 2.15Zm2.028 8.714s38.137-6.511 40.43-8.374c2.293-1.864-10.892.43-18.774 2.006-7.882 1.576-16.927 3.072-20.51 4.219-3.582 1.146-3.726 2.436-1.146 2.15Zm4.285 9.866s38.137-6.512 40.43-8.375c2.293-1.863-10.892.43-18.774 2.006-7.882 1.577-16.927 3.072-20.51 4.219-3.582 1.146-3.726 2.436-1.146 2.15Zm2.027 8.715S89.724 80 92.017 78.138c2.293-1.863-10.891.43-18.773 2.006-7.883 1.576-16.927 3.072-20.51 4.219-3.583 1.146-3.726 2.436-1.147 2.15Z" />
              <path fill="#fff" d="M93.237 69.588c-2.753 4.81-14.668 9.652-16.132 8.807-1.463-.845-2.755-14.924-.017-19.742 6.725-11.648 19.395 1.602 16.15 10.935Z" />
              <path fill="#599EFC" d="m88.504 38.645-10.89 18.863a7.69 7.69 0 0 0-.524 1.144c.87-.587 1.77-.595 2.554.618 2.534 3.923.9 7.928 5.313 5.23 4.413-2.697 3.35 1.063 4.495 3.433.64 1.328 1.616 2.296 3.787 1.655.73-.715 1.321-1.415 1.702-2.075l10.641-18.43c.999-14.523-7.117-16.737-17.078-10.438Z" />
              <path fill="#000" d="M95.635 38.264c-.4-.006-.834.051-1.28.166-2.861.736-14.14 21.658-14.14 21.658l-.059.086c1.802 3.595.726 6.816 4.8 4.327.927-.567 1.61-.846 2.125-.915 2.08-4.377 6.725-14.47 9.235-18.782 2.689-4.62 1.48-6.505-.681-6.54Zm9.827 5.288-16.2 23.934c.055.153.116.303.186.447.64 1.328 1.616 2.296 3.787 1.655.73-.715 1.322-1.415 1.703-2.075l10.64-18.43c.144-2.097.098-3.936-.116-5.531Z" />
              <path fill="#FD6B6A" d="M95.93 30.34c-1.65.008-3.099.81-4.311 2.91l-3.115 5.396c3.13.838 9.363 3.005 14.35 7.875.99.966 1.892 1.809 2.727 2.562l3.365-5.828c2.771-4.8-.946-7.285-5.746-10.056-2.699-1.56-5.15-2.867-7.27-2.858Z" />
              <path fill="#000" d="M75.691 72.616c.288 3.06.836 5.445 1.412 5.778.61.352 3.04-.286 5.863-1.497-1.175-2.765-4.585-3.866-7.275-4.28Zm22.883-40.66c-2.646-1.616-3.063-.058.635 1.965 3.699 2.023 7.397 4.681 8.38 3.988.982-.694-9.015-5.953-9.015-5.953Z" />
              <path fill="#fff" d="M105.577 49.082s-6.731-5.586-10.654-7.343C91 39.982 88.5 38.645 88.5 38.645s.62-.91 5.156.847c4.536 1.757 9.44 5.19 10.911 6.783 1.471 1.594 1.01 2.807 1.01 2.807Z" />
              <path fill="#80D092" d="M38.53 59.291a2.311 2.311 0 1 1-4.623 0 2.311 2.311 0 0 1 4.622 0Z" />
              <path fill="#fff" d="M40.9 68.769a2.312 2.312 0 1 1-4.623 0 2.312 2.312 0 0 1 4.623 0Z" />
              <path fill="#80D092" d="M43.498 78.304a2.311 2.311 0 1 1-4.622 0 2.311 2.311 0 0 1 4.622 0Z" />
              <path fill="#fff" d="M46.158 86.684a2.312 2.312 0 1 1-4.623 0 2.312 2.312 0 0 1 4.623 0Z" />
            </svg>
          </div>
          {lang === "ar" ?
            <div className="reqTnkHdTxt dirRtl">شكرًا لك</div>
            :
            <div className="reqTnkHdTxt">Thank you!</div>
          }
          {lang === "ar" ?
            <div className="reqTnkSubTxt dirRtl">تم إرسال النموذج بنجاح {sourceType}</div>

            :
            <div className="reqTnkSubTxt">{sourceType} request received successfully</div>
          }
          {lang === "ar" ?
            <div className="reqTnkDecTxt dirRtl">
              سيتم التواصل معك قريباً من قبل احد موظفينا لفهم متطلباتك.
            </div>
            :
            <div className="reqTnkDecTxt">One of our insurance advisors will get in touch with you shortly to understand the requirements</div>
          }
          <div className="returnHmBtnSec">
            <Button
              label={lang === "ar" ? "متابعه" : "RETURN TO HOME"}
              status={true}
              isIcon={false}
              clickFunction={() => {
                setSuccessModal(false);
                window.scroll(0, 0)
                window.location.reload(); // Reloads the page
              }}
              buttonType="proceed-btn"
            />
          </div>
        </div>
      </Modal>
      {/* HOME INSURANCE SUCCESS MODAL ENDS HERE */}
    </div>
  );
};

export default Header;
